import { useMemo } from 'react';
import { Screen, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Box } from '~/commonComponents';
import { BackButton } from '~/commonComponents/BackButton';
import { Links } from '~/constants';
import { fireHelpAboutClicked, fireHelpHowItWorksClicked } from '~/posthogs/events';
import { routes } from '~/routes';
import { NumberUtils } from '~/utils/NumberUtils';
import { HelpMenuLink } from './HelpMenuLink';
import { HelpSection } from './HelpSection';

const SOCIAL_LINKS = [
  { text: 'LinkedIn', href: Links.linkedin },
  { text: 'Facebook', href: Links.facebook },
  { text: 'Instagram', href: Links.instagram },
] as const;

export const HelpScreen = () => {
  const csPhoneNumber = useMemo(() => NumberUtils.getCSPhone(), []);

  return (
    <Screen variant="standard">
      <Screen.Header start={<BackButton />} title="Help Center" />
      <Screen.Body>
        <Box
          backgroundColor={colors.neutral[50]}
          flex={1}
          marginHorizontal={56}
          paddingBottom={80}
          paddingHorizontal={40}
          paddingTop={40}
          width="auto"
          gap={12}
          marginBottom={60}
        >
          <HelpSection title="About GoTu">
            <HelpMenuLink to={routes.about} text="About" onClick={fireHelpAboutClicked} />
            <HelpMenuLink
              to={routes.howItWorks}
              text="How it Works"
              onClick={fireHelpHowItWorksClicked}
            />
            <HelpMenuLink
              externalHref={Links.dentistsSideFaqs}
              text="Frequently Asked Questions"
            />
            <HelpMenuLink externalHref={Links.termsOfUse} text="Terms & Conditions" />
            <HelpMenuLink externalHref={Links.privacyPolicy} text="Privacy Policy" />
            {SOCIAL_LINKS.map(({ text, href }) => (
              <HelpMenuLink key={text} externalHref={href} text={text} />
            ))}
          </HelpSection>

          <HelpSection title="Contact Us">
            <Typography as="span" variant="body1">
              Customer Service Text/Call:
              <Typography as="span" bold variant="body1">{` ${csPhoneNumber.formatted}`}</Typography>
            </Typography>
          </HelpSection>
        </Box>
      </Screen.Body>
    </Screen>
  );
};
